import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-header-featured-trail',
  templateUrl: 'trail.component.html'
})
export class HeaderFeaturedTrailComponent {
  @Input() item: any;
  @Input() setting: any;
}
